import { render, staticRenderFns } from "./listStudentStory.vue?vue&type=template&id=3df19461&"
import script from "./listStudentStory.vue?vue&type=script&lang=js&"
export * from "./listStudentStory.vue?vue&type=script&lang=js&"
import style0 from "./listStudentStory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports